import {MappedComponentProperties} from "@adobe/aem-react-editable-components";
import React from "react";
import SeoSchema, { SchemaData } from "../../ui.lib/components/shared/seo-schema/seo-schema";


 const  SeoSchemaComponent = (props: MappedComponentProperties & {"data": any}) => {
  console.log(' Seo Schema-props', props);
  const {data} = props;
  const {schemaType, optionType, jsonSchema, title, metadescription, publishedDate, modifiedDate, metatitle} = data;
  const CMS_SCHEMA_DATA: SchemaData = {
    schemaType: schemaType || 'Article',
    optionType: optionType || 'dynamic',
    jsonSchema,
    title,
    metadescription,
    publishedDate,
    modifiedDate,
    metatitle
  }

  return <>
    <SeoSchema data={CMS_SCHEMA_DATA}/>
  </>;
 };
 
 export default  SeoSchemaComponent;